"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { FilterValue } from "@/shared/types/type/search";
import { ModalProps } from "@/shared/types/interface/modal";
import { useSearchUiStore } from "@/features/search/model/ui/store";
import { TextButton } from "../../atoms";
import { RegionModalContent, RegionModalSideBar } from "@/shared/ui/organisms";
import Modal from ".";
interface RegionModalProps extends ModalProps {
  saveSelectedRegion: (payload?: FilterValue[]) => void;
  hideRegionAllOption?: boolean;
}
const RegionModal = t0 => {
  const $ = _c(31);
  const {
    open,
    onClose,
    saveSelectedRegion,
    hideRegionAllOption
  } = t0;
  const t = useTranslations();
  const {
    selectedRegion,
    selectedSubRegions,
    setSelectedRegion,
    setSelectedSubRegions
  } = useSearchUiStore();
  const [localSelectedRegion, setLocalSelectedRegion] = useState(selectedRegion ?? 1);
  const [localSelectedSubRegions, setLocalSelectedSubRegions] = useState(selectedSubRegions);
  let t1;
  if ($[0] !== localSelectedRegion || $[1] !== localSelectedSubRegions || $[2] !== onClose || $[3] !== saveSelectedRegion || $[4] !== setSelectedRegion || $[5] !== setSelectedSubRegions) {
    t1 = async () => {
      setSelectedRegion(localSelectedRegion);
      setSelectedSubRegions(localSelectedSubRegions);
      onClose();
      saveSelectedRegion(localSelectedSubRegions);
    };
    $[0] = localSelectedRegion;
    $[1] = localSelectedSubRegions;
    $[2] = onClose;
    $[3] = saveSelectedRegion;
    $[4] = setSelectedRegion;
    $[5] = setSelectedSubRegions;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const searchRegion = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setLocalSelectedRegion(1);
      setLocalSelectedSubRegions([]);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleReset = t2;
  let t3;
  let t4;
  if ($[8] !== selectedSubRegions) {
    t3 = () => {
      setLocalSelectedSubRegions(selectedSubRegions);
    };
    t4 = [selectedSubRegions];
    $[8] = selectedSubRegions;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  if ($[11] !== t) {
    t5 = t("commonRegionModal.title");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== localSelectedRegion) {
    t6 = <RegionModalSideBar selectedRegion={localSelectedRegion} setSelectedRegion={setLocalSelectedRegion} />;
    $[13] = localSelectedRegion;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== hideRegionAllOption || $[16] !== localSelectedRegion || $[17] !== localSelectedSubRegions) {
    t7 = <RegionModalContent selectedRegion={localSelectedRegion} selectedSubRegions={localSelectedSubRegions} setSelectedSubRegions={setLocalSelectedSubRegions} hideRegionAllOption={hideRegionAllOption} />;
    $[15] = hideRegionAllOption;
    $[16] = localSelectedRegion;
    $[17] = localSelectedSubRegions;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex min-h-0 flex-1 border-t border-[#EAEBEC]">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <TextButton text={"\uCD08\uAE30\uD654"} className="w-[33%] py-3 bg-white border border-gray-200 text-gray-700 rounded font-medium" onClick={handleReset} />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== searchRegion) {
    t10 = <div className="flex shrink-0 gap-[6px] border-t border-[#EAEBEC] bg-white px-4 py-3">{t9}<TextButton text={"\uC644\uB8CC"} className="w-[66%] py-3 bg-primary-600 text-white rounded font-semibold disabled:bg-[#F7F7F7] disabled:text-[#989BA2] disabled:cursor-not-allowed" onClick={() => searchRegion()} /></div>;
    $[23] = searchRegion;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== onClose || $[26] !== open || $[27] !== t10 || $[28] !== t5 || $[29] !== t8) {
    t11 = <Modal open={open} onClose={onClose} height="90%" title={t5} titlePosition="center">{t8}{t10}</Modal>;
    $[25] = onClose;
    $[26] = open;
    $[27] = t10;
    $[28] = t5;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
export default RegionModal;